import { IconProps } from './types';

export const IconHistory = ({ size = 20, color = 'currentColor', ...props }: IconProps) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 24 24' fill='none' {...props}>
    <path d='M12 8V12L15 15' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M3.05 11a9 9 0 1 1 .5 9m-.5-9v-5.5h-5.5' stroke={color} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);

export default IconHistory;
